import { useEffect, useState } from "react";

const LoadingScreen = () => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 1500); // Show loading screen for 1.5 seconds minimum

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`fixed inset-0 bg-white flex items-center justify-center z-50 transition-opacity duration-500 ${
        fadeOut ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div className="flex flex-col items-center space-y-4">
        <img
          src="/lovable-uploads/24972437-aa8b-4772-a032-7db8f669e478.png"
          alt="Functional Foodie Logo"
          className="w-32 h-32 object-contain animate-pulse"
        />
        <div className="text-primary font-montserrat font-semibold text-xl">
          Loading...
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;